<template>
  <div class="_con" style="background-color: #0d0d0d; min-height: 100vh;">
    
    <!-- YÜKLENİRKEN GÖSTERİLECEK TEMİZ EKRAN (Denizaltı resmi kaldırıldı) -->
    <div v-if="loading" style="display: flex; justify-content: center; align-items: center; min-height: 100vh; width: 100%;">
      <span style="color: #fff; font-family: 'DM Sans', sans-serif; letter-spacing: 2px; font-size: 14px; opacity: 0.7;">YÜKLENİYOR...</span>
    </div>

    <!-- GERÇEK SLİDER (Veritabanından Gelenler) -->
    <ul class="slides" v-else-if="realImages.length > 0">
      <li
        v-for="(slide, index) in realImages"
        :key="slide.id"
        :class="{
          active: currentImage === index,
          prevSlide: prevImage === index,
        }"
      >
        <img :src="slide.img" />

        <div class="sliderTagContainer">
          <div class="sliderTag" :class="{ activeTag: currentImage === index }">
            <div>&bull; {{ slide.tag }}</div>
          </div>
        </div>

        <div class="sliderTextContainer">
          <div class="sliderTitle" :class="{ activeTitle: currentImage === index }">
            <div>{{ slide.title }}</div>
          </div>
        </div>

        <div class="sliderButonContainer">
          <div class="sliderButon" :class="{ activeButon: currentImage === index }" @click.stop.prevent="handleSliderClick(slide.link)">
            <Button :link="''" :text="$t('home.slider.buttonText') || 'Daha Fazla'" style="pointer-events: none;" type="light"/>
          </div>
        </div>
      </li>
    </ul>

    <!-- EĞER HİÇ ÜRÜN VEYA PROJE EKLENMEMİŞSE (Çökmeyi Önler) -->
    <div v-else style="display:flex; justify-content:center; align-items:center; min-height: 100vh; color: #555;">
       <h3 style="font-weight: 300; letter-spacing: 1px;">Sisteme kayıtlı slider bulunamadı. Lütfen Admin panelinden ekleyin.</h3>
    </div>
    
    <!-- NOKTA YÖNLENDİRMELERİ -->
    <ul class="navdot" v-if="!loading && realImages.length > 1">
      <li
        v-for="(slide, index) in realImages"
        :key="'dot-' + slide.id"
        :class="{ active: currentImage === index }"
        @click="scroll_to_slide(index)"
      ></li>
    </ul>
  </div>
</template>

<script>
import Button from "../common/Button.vue";
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore, collection, getDocs, query, where } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBxpNV_8UazGQ3pMReWWIdROn7AZlMT17Y",
  authDomain: "baumind-45d99.firebaseapp.com",
  projectId: "baumind-45d99",
  storageBucket: "baumind-45d99.firebasestorage.app",
  messagingSenderId: "982282716223",
  appId: "1:982282716223:web:25ebcf827c8e87c555248a",
  measurementId: "G-FDZLC80DZ2"
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const db = getFirestore(app);

export default {
  name: "Slider",
  components: {
    Button,
  },
  data() {
    return {
      currentImage: 0,
      prevImage: null,
      lastClickTime: 0,
      loading: true,
      realImages: [],
      autoPlayInterval: null,
    };
  },
  methods: {
    handleSliderClick(link) {
      if (link) {
        const locale = this.$i18n.locale || 'tr';
        this.$router.push(`/${locale}/${link}`);
      }
    },
    autoIncrement() {
      this.autoPlayInterval = setInterval(() => {
        if (Date.now() - this.lastClickTime < 5000) return;
        if (this.realImages.length > 1) {
          this.prevImage = this.currentImage;
          this.currentImage = (this.currentImage + 1) % this.realImages.length;
        }
      }, 5000);
    },
    scroll_to_slide(index) {
      if (this.currentImage === index) return; 
      this.prevImage = this.currentImage;
      this.currentImage = index;
      this.lastClickTime = Date.now();
    },
    async fetchSliders() {
      let items = [];
      try {
        // Ürünler Veritabanından Çek
        const qUrunler = query(collection(db, "urunler"), where("showInSlider", "==", true));
        const urunlerSnap = await getDocs(qUrunler);
        urunlerSnap.forEach(doc => {
          let data = doc.data();
          if (data.sliderImage) { 
            items.push({
              id: doc.id,
              tag: (data.tags && data.tags.length > 0) ? data.tags[0] : 'ÜRÜN',
              title: data.title || 'BAUMIND Ürün',
              img: data.sliderImage,
              link: `products/${doc.id}`
            });
          }
        });

        // Projeler Veritabanından Çek
        const qProjeler = query(collection(db, "projeler"), where("showInSlider", "==", true));
        const projelerSnap = await getDocs(qProjeler);
        projelerSnap.forEach(doc => {
          let data = doc.data();
          if (data.sliderImage) { 
            items.push({
              id: doc.id,
              tag: (data.tags && data.tags.length > 0) ? data.tags[0] : 'PROJE',
              title: data.title || 'BAUMIND Proje',
              img: data.sliderImage,
              link: `projects/${doc.id}`
            });
          }
        });
      } catch (error) {
        console.error("Firebase Hatası:", error);
      } finally {
        this.realImages = items;
        this.loading = false;
        
        // Eğer birden fazla görsel varsa döngüyü başlat
        if (this.realImages.length > 1) {
          this.autoIncrement();
        }
      }
    }
  },
  mounted() {
    this.fetchSliders();
  },
  beforeUnmount() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
    }
  }
};
</script>

<style scoped>
*, *::before, *::after { box-sizing: inherit; margin: 0; padding: 0; }
._con { display: flex; justify-content: center; margin: 0 0; padding-right: 0px; padding-left: 0px; font-family: "DM Sans", sans-serif; position: relative; }
.slides { overflow: hidden; width: 100%; min-height: 100vh; padding-right: 0px; padding-left: 0px; }

.slides li { 
  width: 100%; 
  min-height: 100vh; 
  position: absolute; 
  z-index: 1; 
  padding-right: 0px; 
  padding-left: 0px; 
  opacity: 0; 
  visibility: hidden; 
}

.slides img { width: 100%; height: 100vh; object-fit: cover; object-position: top; }

.slides li.active { 
  opacity: 1; 
  visibility: visible; 
  z-index: 3; 
  animation-name: slide; 
  animation-duration: 1s; 
  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1); 
  animation-iteration-count: 1; 
  animation-fill-mode: forwards; 
}

.slides li.prevSlide { 
  opacity: 1; 
  visibility: visible; 
  z-index: 2; 
}

@keyframes slide { 0% { transform: translateY(-100%); } 100% { transform: translateY(0%); } }

.sliderTagContainer { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -420%); width: 90%; padding-top: 10px; padding-bottom: 10px; display: flex; justify-content: center; align-items: center; flex-direction: column; z-index: 2; overflow: hidden; }
.sliderTag { width: 100%; background-color: transparent; text-align: center; color: #fff; font-family: "DM Sans", sans-serif; font-size: 12px; font-weight: 400; text-transform: uppercase; letter-spacing: 2px; z-index: 4; display: flex; justify-content: center; align-items: center; }
.activeTag { z-index: 6; animation-name: slideTag; animation-duration: 1.6s; animation-delay: 0s; animation-timing-function: ease-in-out; animation-fill-mode: forwards; animation-iteration-count: 1; animation-direction: normal; }
@keyframes slideTag { 0% { transform: translateY(300%); } 100% { transform: translateY(0%); } }
.sliderTextContainer { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -55%); width: 700px; padding-top: 10px; padding-bottom: 10px; display: flex; justify-content: center; align-items: center; flex-direction: column; z-index: 2; overflow: hidden; }
.sliderTitle { width: 100%; background-color: transparent; text-align: center; color: #fff; font-size: 65px; font-weight: 400; line-height: 90px; z-index: 4; display: flex; justify-content: center; align-items: center; }
.activeTitle { z-index: 6; animation-name: slideTitle; animation-duration: 1.6s; animation-delay: 0s; animation-timing-function: ease-in-out; animation-fill-mode: forwards; animation-iteration-count: 1; animation-direction: normal; }
@keyframes slideTitle { 0% { transform: translateY(300%); } 100% { transform: translateY(0%); } }
.sliderButonContainer { position: absolute; top: 50%; left: 50%; transform: translate(-50%, 180%); width: 100%; padding-top: 10px; padding-bottom: 10px; display: flex; justify-content: center; align-items: center; flex-direction: column; z-index: 2; overflow: hidden; cursor: pointer; }
.activeButon { z-index: 6; animation-name: slideButton; animation-duration: 1.6s; animation-delay: 0s; animation-timing-function: ease-in-out; animation-fill-mode: forwards; animation-iteration-count: 1; animation-direction: normal; }
@keyframes slideButton { 0% { transform: translateY(-300%); } 100% { transform: translateY(0%); } }
.navdot { position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); margin: 0; padding: 0; list-style: none; z-index: 4; display: flex; flex-direction: row; transition: all 1s ease; }
.navdot li { height: 10px; width: 10px; border: solid 1px white; border-radius: 10px; cursor: pointer; margin: 0 10px; }
.navdot li:last-child { margin-bottom: 0; }
.navdot li.active { background: white; }
@media screen and (max-width: 1023px) { .sliderTextContainer { width: 80%; } .sliderTitle { width: 100%; text-align: center; font-size: 40px; line-height: 55px; } }
</style>